export default __webpack_public_path__ + "static/media/2.d707a829.png";